import { Layer, Toggle } from "@carbon/react";
import { FC, useEffect, useState } from "react";

import { TableToolbarFilter } from "src/components/Tables/TableToolbarFilter.tsx";
import { useT } from "src/internationalization";

export type CasesFilterFilterProps = {
  onApplyFilter: (values: FilterState) => void;
  onResetFilter: () => void;
  values: FilterState;
};

type FilterState = {
  onlyScored: boolean;
};

export const CasesFilter: FC<CasesFilterFilterProps> = ({
  onApplyFilter,
  onResetFilter,
  values,
}) => {
  const [onlyScored, setOnlyScored] = useState(values.onlyScored);
  const t = useT();

  useEffect(() => {
    setOnlyScored(values.onlyScored);
  }, [values]);

  return (
    <TableToolbarFilter
      onApplyFilter={() => onApplyFilter({ onlyScored })}
      onResetFilter={onResetFilter}
      onPopoverClose={() => setOnlyScored(values.onlyScored)}
      numberOfFiltersApplied={values.onlyScored !== false ? 1 : 0}
    >
      <Layer level={2} className="w-[500px]">
        <Toggle
          id="score-greater-zero-filter"
          labelA={t("page.cases.tab.requests.table.filter.scored.label")}
          labelB={t("page.cases.tab.requests.table.filter.scored.label")}
          size="sm"
          toggled={onlyScored}
          onToggle={setOnlyScored}
        />
      </Layer>
    </TableToolbarFilter>
  );
};
